export default "__VITE_ASSET__wSytIqlo__"